module.exports = __webpack_public_path__ + "static/wallpaper8-b5bedf9fd9b8fb795d198c5567ac0d5a.jpg";